import React from 'react';
import { Box, Typography } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';
import { BRAND } from '../../theme/brandTokens';

const FormStepper = ({ id, steps, activeStep, onStepSelect }) => (
  <Box
    id={id}
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'stretch',
      position: 'relative',
    }}
  >
    {steps.map((step, index) => {
      const reached = activeStep >= index;
      const complete = activeStep > index;
      const canSelect = typeof onStepSelect === 'function' && index < activeStep;

      return (
        <Box
          key={step.id || index}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flex: 1,
            position: 'relative',
          }}
        >
          <Box
            component={canSelect ? 'button' : 'div'}
            type={canSelect ? 'button' : undefined}
            id={id ? `${id}-step-${index + 1}` : undefined}
            aria-label={step.label}
            aria-current={activeStep === index ? 'step' : undefined}
            onClick={canSelect ? () => onStepSelect(index) : undefined}
            sx={{
              width: 36,
              height: 36,
              borderRadius: '50%',
              background: reached ? BRAND.accent : BRAND.surface,
              color: reached ? BRAND.onAccent : BRAND.textMuted,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.95rem',
              fontWeight: 700,
              border: `2px solid ${reached ? BRAND.accent : BRAND.line}`,
              cursor: canSelect ? 'pointer' : 'default',
              p: 0,
              fontFamily: 'inherit',
              zIndex: 2,
              position: 'relative',
            }}
          >
            {complete ? <CheckIcon sx={{ fontSize: 18 }} /> : index + 1}
          </Box>
          <Typography
            sx={{
              color: reached ? BRAND.text : BRAND.textMuted,
              fontWeight: reached ? 700 : 500,
              fontSize: '0.8rem',
              mt: 1,
              textAlign: 'center',
              display: { xs: 'none', sm: 'block' },
              lineHeight: 1.25,
              width: '100%',
              px: 0.5,
            }}
          >
            {step.label}
          </Typography>
          {index < steps.length - 1 ? (
            <Box
              sx={{
                position: 'absolute',
                top: 18,
                left: 'calc(50% + 18px)',
                right: 'calc(-50% + 18px)',
                height: '2px',
                background: complete ? BRAND.accent : BRAND.line,
                zIndex: 1,
              }}
            />
          ) : null}
        </Box>
      );
    })}
  </Box>
);

export default FormStepper;
